import type { IBusiness, ITransaction } from '@recargas-dominicanas/core/types';
import { center, colums, line, newLine, print } from './print';
import { formatCurrency, formatPhone, formatRef, formatTime, formatTopupNumber } from '@recargas-dominicanas/core/utils';
import { formatDatePart } from './formatDate';

export function printTopup(business: IBusiness, transaction: ITransaction) {

  const topupNumber = formatTopupNumber(transaction.product, transaction.phone);

  print([
    center(business.name.toLocaleUpperCase()),
    center(formatPhone(business.phone)),
    center(business.address),
    newLine(),
    line(),
    transaction.product.key === 'edesur:topup'
      ? center('RECARGA EDESUR')
      : center('RECARGA'),
    line(),
    newLine(),
    colums('Compañía', transaction.product.name),
    transaction.ownerName && colums('Titular', transaction.ownerName),
    colums(topupNumber.title, topupNumber.value),
    colums('Monto', formatCurrency(transaction.amount)),
    transaction.energyTopup?.kwh && colums('Monto recargado', transaction.energyTopup.kwh),
    transaction.energyTopup?.tariff && colums('Tarifa', transaction.energyTopup.tariff),
    transaction.energyTopup?.batch && colums('Lote', transaction.energyTopup.batch),
    transaction.energyTopup?.meter && colums('Medidor', transaction.energyTopup.meter),
    colums('Fecha', formatDatePart(transaction.date)),
    colums('Hora', formatTime(transaction.date)),
    colums('Referencia', formatRef(transaction.reference!)),
    ...kwhPrices(transaction),
    newLine(),
    line(),
    newLine(),
    center(transaction.cancelled ? 'RECARGA CANCELADA' : '¡Gracias por su compra!'),
    newLine()
  ]);
}

function kwhPrices(transaction: ITransaction) {

  if (!transaction.energyTopup?.kwhPerTariff) return [];
  
  return [
    newLine(),
    'Desglose escalonado de precios:',
    newLine(),
    newLine(),
    colums('Tarifa', 'kWh recargados'),
    line(),
    ...transaction.energyTopup.kwhPerTariff.map(item => colums(item.tariff, `${item.amount} kWh`)),
    newLine(),
    colums('Total recargado:', `${transaction.energyTopup.totalKwh} kWh`),
    newLine(),
    line(),
    newLine(),
    center('Si presenta algún inconveniente con su'),
    center('recarga, favor comunicarse al número'),
    center('(809) 683-9393')
  ];
}
